module.exports = __webpack_public_path__ + "img/VINID1.39372db8.svg";